export default class ExpandingInfo {
	constructor(domNode) {
		this.rootEl = domNode;
		this.trigger = this.rootEl.querySelector(".info-block-trigger");

		const controlsId = this.trigger.getAttribute("aria-controls");
		this.contentEl = document.getElementById(controlsId);

		// Set initial state
		this.trigger.setAttribute("aria-expanded", "false");
		this.open = false;
		// set state to hidden on init
		this.contentEl.setAttribute("hidden", "hidden");

		this.parent = this.contentEl.parentElement;

		// Add event listeners
		this.trigger.addEventListener("click", () => {
			this.toggle(!this.open);
		});
	}

	toggle(open) {
		// Don't do anything if the open state doesn't change
		if (open === this.open) {
			return;
		}

		// Update the internal state
		this.open = open;

		// Handle DOM updates
		this.trigger.setAttribute("aria-expanded", `${open}`);
		if (open) {
			this.contentEl.removeAttribute("hidden");
			this.contentEl.classList.add("active");
			this.parent.classList.add("active");
		} else {
			this.contentEl.setAttribute("hidden", "");
			this.contentEl.classList.remove("active");
			this.parent.classList.remove("active");
		}
	}

	// Add public open and close methods for convenience
	open() {
		this.toggle(true);
	}

	close() {
		this.toggle(false);
	}
}
